
// src/utils/dates.ts
import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const TIME_ZONE = 'America/Sao_Paulo';

export const formatToSaoPaulo = (date: string | Date, formatString = 'dd/MM/yyyy HH:mm') => {
    if (!date) return 'N/A';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const zonedDate = toZonedTime(dateObj, TIME_ZONE);
    return format(zonedDate, formatString);
};
